import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ActivityHistoryEntry, Profile } from "PFTypes";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { useTranslatedActivityType } from "../../../../hooks/use_translated_activity_type";
import css from "../history_entry.scss";
import { HistoryEntryDataPlaceholder } from "./history_entry_data_placeholder";
import { HistoryEntryProfile } from "./history_entry_profile";
import { HistoryEntryRow } from "./history_entry_row";

export type HistoryEntryHeaderProps = {
  profile: Profile | undefined;
  isLoading: boolean | undefined;
} & Pick<ActivityHistoryEntry, "event" | "createdAt">;

export const HistoryEntryHeader = ({ profile, event, createdAt, isLoading }: HistoryEntryHeaderProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.history" });
  const { formatDateTime } = useDateFormatter();
  const activityType = useTranslatedActivityType();

  if (isLoading) {
    return <HistoryEntryDataPlaceholder height="40px" />;
  }

  if (!profile) {
    return null;
  }

  return (
    <HistoryEntryRow>
      <HistoryEntryProfile
        profile={profile}
        title={
          <div className={css.title}>
            <Trans
              t={t}
              i18nKey={`entry.message.${event}`}
              values={{ profile: getProfileName(profile), activityType }}
              components={{
                bold: <Typography variant="bodyBold" noMargin />,
                normal: <Typography variant="bodyRegular" noMargin />
              }}
            />
          </div>
        }
        subtitle={formatDateTime(createdAt)}
      />
    </HistoryEntryRow>
  );
};
